import { enUS } from './translationENUS';
import { ptBR } from './translationPTBR';

export type Locale = 'pt-BR' | 'en-US';

export const translations = {
  'pt-BR': ptBR,
  'en-US': enUS,
} as const;

export type TranslationKey = keyof typeof ptBR | string;

export const defaultLocale: Locale = 'pt-BR';